import React from "react";
import "./InputRadioGroup.scss";

type RadioOption = {
  value: string;
  label: string;
};

type RadioGroup = {
  label?: string;
  options: RadioOption[];
};

type InputRadioGroupProps = {
  name: string;
  options: RadioGroup[];
  selectedValue?: string;
  onChange?: (value: string) => void;
  spacing?: string;
  align?: "flex-start" | "center" | "flex-end" | "space-between";
  groupLabel?: string;
};

const InputRadioGroup: React.FC<InputRadioGroupProps> = ({
  name,
  options,
  selectedValue,
  onChange,
  spacing = "12px",
  align = "flex-start",
  groupLabel,
}) => {
  const handleChange = (value: string) => {
    onChange?.(value);
  };

  return (
    <div className="input-radiogroup">
      {groupLabel && (
        <div className="input-radiogroup__header">
          <span className="input-radiogroup__grouplabel">{groupLabel}</span>
        </div>
      )}
      
      {options.map((group, groupIndex) => (
        <div key={groupIndex} className="input-radiogroup__group">
          {group.label && (
            <div className="input-radiogroup__grouplabel">
              {group.label}
            </div>
          )}
          {group.options.map((option) => (
            <div
              key={option.value}
              className={`input-radio ${align}`}
              style={{ justifyContent: align }}
            >
              <input
                type="radio"
                name={name}
                id={`${name}-${option.value}`}
                checked={selectedValue === option.value}
                onChange={() => handleChange(option.value)}
                className="input-radio__input"
              />
              <label
                htmlFor={`${name}-${option.value}`}
                className="input-radio__label"
                style={{ marginLeft: align !== "space-between" ? spacing : "0" }}
              >
                {option.label}
              </label>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default InputRadioGroup;